import 'scss/services/sound-feature-recg.scss'
import 'babel-polyfill'
import {
  serviceTopbar
} from 'js/libs/utils-services'
import {
  init as initServiceOpen,
  showserviceOpenModal
} from 'js/libs/utils-services-open'
import { config } from 'config'
import 'js/libs/gt'
import { toUrl } from 'js/libs/utils'

// var buffer
// if (window.AudioContext || window.webkitAudioContext) {
//   var context = new (window.AudioContext || window.webkitAudioContext)()
//   var recorder = context.createScriptProcessor(4096, 1, 1)
// }
// var size = 0
// // var recorder = context.createScriptProcessor(4096, 1, 1)
// var result
// var ageMap = {
//   '1': {
//     name: '小孩',
//     code: 'child'
//   },
//   '0': {
//     name: '中年',
//     code: 'middle'
//   },
//   '2': {
//     name: '老年',
//     code: 'old'
//   }
// }
// var genderMap = {
//   '0': {
//     name: '女性',
//     code: 'female'
//   },
//   '1': {
//     name: '男性',
//     code: 'male'
//   }
// }
// navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia
// function startRecord () {
//   var dialect = $('.dialect-select').find('option:selected').text()
//   if (navigator.getUserMedia) {
//     navigator.getUserMedia({
//       audio: true,
//       video: false
//     }, function (e) {
//       // 从麦克风的输入流创建源节点
//       $('.taste-content').css('display', 'none')
//       $('.start-taste').addClass('flex-display-1')
//       $('.dialect-select').css('display', 'none')
//       $('.start-button').text('结束识别')
//       $('.time-box').addClass('flex-display-1')
//       $('.dialect').text(dialect).css('display', 'inline-block')
//       oneMinute($('.used-time'))
//       var stream = context.createMediaStreamSource(e)
//       // 用于录音的processor节点
//       buffer = []
//       stream.connect(recorder)
//       size = 0
//       recorder.onaudioprocess = function (e) {
//         buffer.push(new Float32Array(e.inputBuffer.getChannelData(0)))
//         size += e.inputBuffer.getChannelData(0).length
//       }
//       recorder.connect(context.destination)
//     }, function (e) {
//       console.log('请求麦克风失败')
//       $.alerts.alert('请求麦克风失败')
//     })
//   } else {
//     $.alerts.alert('您现在使用的浏览器暂时不支持体验功能，推荐使用谷歌浏览器Chrome')
//   }
// }
// function compress () {
//   var data = new Float32Array(size)
//   var offset = 0
//   for (var i = 0; i < buffer.length; i++) {
//     data.set(buffer[i], offset)
//     offset += buffer[i].length
//   }
//   var fitCount = Math.round(data.length * (16000 / 44100))
//   var newData = new Float32Array(fitCount)
//   var springFactor = (data.length - 1) / (fitCount - 1)
//   newData[0] = data[0]
//   for (i = 1; i < fitCount - 1; i++) {
//     var tmp = i * springFactor
//     var before = Math.floor(tmp).toFixed()
//     var after = Math.ceil(tmp).toFixed()
//     var atPoint = tmp - before
//     newData[i] = data[before] + (data[after] - data[before]) * atPoint
//   }
//   newData[fitCount - 1] = data[data.length - 1]
//   return newData
// }
// function encodeWAV () {
//   // recorder.disconnect()
//   var sampleRate = 16000
//   var sampleBits = 16
//   var bytes = compress()
//   var dataLength = bytes.length * (sampleBits / 8)
//   var buffer = new ArrayBuffer(44 + dataLength)
//   var data = new DataView(buffer)
//   var channelCount = 1 // 单声道
//   var offset = 0
//   var writeString = function (str) {
//     for (var i = 0; i < str.length; i++) {
//       data.setUint8(offset + i, str.charCodeAt(i))
//     }
//   }
//   writeString('RIFF')
//   offset += 4
//   data.setUint32(offset, 36 + dataLength, true)
//   offset += 4
//   writeString('WAVE')
//   offset += 4
//   // 波形格式标志
//   writeString('fmt ')
//   offset += 4
//   // 过滤字节,一般为 0x10 = 16
//   data.setUint32(offset, 16, true)
//   offset += 4
//   // 格式类别 (PCM形式采样数据)
//   data.setUint16(offset, 1, true)
//   offset += 2
//   // 通道数
//   data.setUint16(offset, channelCount, true)
//   offset += 2
//   // 采样率,每秒样本数,表示每个通道的播放速度
//   data.setUint32(offset, sampleRate, true)
//   offset += 4
//   // 波形数据传输率 (每秒平均字节数) 单声道×每秒数据位数×每样本数据位/8
//   data.setUint32(offset, channelCount * sampleRate * (sampleBits / 8), true)
//   offset += 4
//   // 快数据调整数 采样一次占用字节数 单声道×每样本的数据位数/8
//   data.setUint16(offset, channelCount * (sampleBits / 8), true)
//   offset += 2
//   // 每样本数据位数
//   data.setUint16(offset, sampleBits, true)
//   offset += 2
//   // 数据标识符
//   writeString('data')
//   offset += 4
//   // 采样数据总数,即数据总大小-44
//   data.setUint32(offset, dataLength, true)
//   offset += 4
//   for (var i = 0; i < bytes.length; i++, offset += 2) {
//     var s = Math.max(-1, Math.min(1, bytes[i]))
//     data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true)
//   }
//   var blob = new Blob([data], {
//     type: 'audio/wav'
//   })
//   document.querySelector('audio').src = window.URL.createObjectURL(blob)
//   // var reader = new FileReader()
//   // reader.readAsArrayBuffer(blob)
//   // reader.onload = function (e) {
//   //   var base64 = btoa(new Uint8Array(reader.result)
//   //     .reduce((data, byte) => data + String.fromCharCode(byte), '')
//   //   )
//   // var params = {
//   //   file: blob
//   // }
//   var challenge = result.geetest_challenge
//   var validate = result.geetest_validate
//   var seccode = result.geetest_seccode
//   var params = new FormData()
//   params.append('file', blob)
//   params.append('aue', 'wav')
//   debugger
//   $.ajax({
//     url: '/herapi/product/igrGray?challenge=' + challenge + '&validate=' + validate + '&seccode=' + seccode,
//     type: 'POST',
//     dataType: 'json',
//     data: params,
//     contentType: false,
//     processData: false,
//     // contentType: 'application/json; charset=utf-8',
//     beforeSend: function () {
//       layer.open('.modal-wrapper-alert')
//     },
//     success: function (res) {
//       layer.close('.modal-wrapper-alert')
//       if (res.code === 0) {
//         let resobj = JSON.parse(res.data)
//         let gender = genderMap[resobj.gender.gender_type]
//         let age = ageMap[resobj.age.age_type]
//         $('#genderText').text(`${gender.name}（${(Number(resobj.gender[gender.code]) * 100).toFixed(2)}%）`)
//         $('#ageText').text(`${age.name}（${(Number(resobj.age[age.code]) * 100).toFixed(2)}%）`)
//       } else if (res.code === 99999) {
//         $.alerts.alert('系统异常，请稍后重试')
//       } else if (res.code === 20011) {
//         $.alerts.alert('验证码校验失败，请重试')
//       }
//     },
//     error: function () {
//       resolve({})
//     }
//   })
//   // }
// }
// function returnStart () {
//   time = 0
//   clearTimeout(timeout)
//   $('.time-box').removeClass('flex-display-1').css('display', 'none')
//   $('.start-button').text('开始识别')
//   $('.dialect').css('display', 'none')
//   $('.dialect-select').css('display', 'inline-block')
// }
// function finish () {
//   recorder.disconnect()
//   encodeWAV()
// }
// var time = 0
// var timeout
// function oneMinute (o) {
//   if (time === 8) {
//     o.text('00: 30')
//     recorder.disconnect()
//     finish()
//     $('hr').removeClass('hr')
//     time++
//   } else if (time === 9) {
//     returnStart()
//     return false
//   } else if (time >= 0 && time < 10) {
//     o.text('00: 0' + time)
//     time++
//   } else {
//     o.text('00: ' + time)
//     time++
//   }
//   // encodeWAV()
//   timeout = setTimeout(function () {
//     oneMinute(o)
//   }, 1000)
// }
// var handler = function (captchaObj) {
//   captchaObj.onReady(function () {
//     $('#wait').hide()
//   }).onSuccess(function () {
//     result = captchaObj.getValidate()
//     if (!result) {
//       return $.alerts.alert('请完成验证')
//     }
//     $('hr').addClass('hr')
//     startRecord()
//   }).onError(function () {
//     $.alerts.alert('验证码校验失败，请重试')
//   })

//   $('#taste_button').click(function () {
//     if (window.AudioContext || window.webkitAudioContext) {
//       context = new (window.AudioContext || window.webkitAudioContext)()
//       recorder = context.createScriptProcessor(4096, 1, 1)
//     }
//     if (window.ActiveXObject || 'ActiveXObject' in window) {
//       $.alerts.alert('您现在使用的浏览器暂时不支持体验功能，推荐使用谷歌浏览器Chrome')
//     } else {
//       captchaObj.verify()
//     }
//   })
//   $('.start-button').click(function () {
//     if ($(this).text() === '开始识别') {
//       $('#genderText').text('')
//       $('#ageText').text('')
//       captchaObj.verify()
//     } else {
//       returnStart()
//       finish()
//     }
//   })
// }
// 极验初始化
// var geetestApi = function () {
//   $.ajax({
//     url: '/herapi/plug/geetestInit',
//     type: 'get',
//     dataType: 'json',
//     success: function (data) {
//       // 调用 initGeetest 进行初始化
//       // 参数1：配置参数
//       // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它调用相应的接口
//       initGeetest({
//         // 以下 4 个配置参数为必须，不能缺少
//         gt: data.data.gt,
//         challenge: data.data.challenge,
//         offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
//         new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机
//         product: 'bind', // 产品形式，包括：float，popup
//         width: '300px'
//         // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
//       }, handler)
//     }
//   })
// }
$(function () {
  serviceTopbar()
  initServiceOpen()
  $('.to-service-apply').click(function () {
    toUrl(`${config.CONSOLE}workorder/commit?category=e68db97312ec4f03a0c6904673f80c84&tid=34c84ab81cf44f92bfe225fd4c9a6e6f&categoryName=性别年龄识别&tname=商务接洽&title=性别年龄识别 - 商务合作&id=igr_gray`, '_blank')
  })
  $('.to-service-open').click(function () {
    showserviceOpenModal({
      urlParams: { 'currPage': '1' }
    }, {
      detailUrl: `${config.CONSOLE}/app/myapp`,
      appIdKey: 'keyword',
      needBase64: false
    })
  })
  // geetestApi()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/sound-feature-recg.js